import { render, staticRenderFns } from "./inactive.vue?vue&type=template&id=37957d9e&scoped=true"
import script from "./inactive.vue?vue&type=script&lang=js"
export * from "./inactive.vue?vue&type=script&lang=js"
import style0 from "./inactive.vue?vue&type=style&index=0&id=37957d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37957d9e",
  null
  
)

export default component.exports